import { render } from "./_modal-accepted-funds.vue?vue&type=template&id=19b0d00e"
import script from "./_modal-accepted-funds.vue?vue&type=script&lang=js"
export * from "./_modal-accepted-funds.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__